export const createMessageId = (role: 'u' | 'a' = 'u'): string =>
  `${role}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
